import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { logout, getUser } from '../services/auth';
import BrandLogo from './BrandLogo';

const AdminHeader: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const user = getUser();

  const handleLogout = () => {
    logout();
    window.location.href = '/';
  };

  const handleNavigation = (path: string) => {
    navigate(path);
    setMenuOpen(false);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="app-header">
      <div className="container">
        <span style={{ marginRight: 'auto' }}>
          <BrandLogo height={17} withIcon />
        </span>
        <div className="header-actions">
          <div className="admin-menu-container">
            <button
              className="burger-menu-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              <span className="burger-line"></span>
              <span className="burger-line"></span>
              <span className="burger-line"></span>
            </button>
            {menuOpen && (
              <div className="admin-menu-dropdown">
                <div
                  className={`admin-menu-item ${isActive('/admin/orders') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/orders')}
                >
                  Bestellungen
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/analytics') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/analytics')}
                >
                  Auswertungen
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/billing') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/billing')}
                >
                  Abrechnung
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/dealers') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/dealers')}
                >
                  Händler
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/settings') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/settings')}
                >
                  Einstellungen
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/models') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/models')}
                >
                  Modelle
                </div>
                <div
                  className={`admin-menu-item ${isActive('/admin/audit-logs') ? 'active' : ''}`}
                  onClick={() => handleNavigation('/admin/audit-logs')}
                >
                  Audit-Logs
                </div>
                <div className="admin-menu-divider"></div>
                <div className="admin-menu-item" onClick={handleLogout}>
                  Abmelden
                </div>
              </div>
            )}
          </div>
          <span className="user-info">Angemeldet als: {user?.username}</span>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;

